/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmEmailRequestsRoute } from '@jira/router-routes__products-jsm-email-requests-routes/src/productsJsmEmailRequestsRoute.tsx';
import ProductsJsmEmailRequests, { LazyProductsJsmEmailRequests } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const productsJsmEmailRequestsRouteEntry: Route = createEntry(
	productsJsmEmailRequestsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-email-requests',
		// eslint-disable-next-line no-restricted-syntax
		component: ProductsJsmEmailRequests,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		forPaint: [LazyAtlassianNavigation, LazyProductsJsmEmailRequests],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
